module.exports = __webpack_public_path__ + "img/signin-banner.79e2e6da.svg";